import { tokenAliasOrValue } from "./base";
import { DimensionUnit } from "./dimension";
import { z } from "zod";
export const ParagraphIndentUnit = z.enum(["Pixels", "Rem", "Percent"]);
export const ParagraphIndentValue = z.object({
    unit: DimensionUnit,
    measure: z.number(),
});
export const ParagraphIndentTokenData = tokenAliasOrValue(ParagraphIndentValue);
